import { CURRENT_FORM_SCHEMA } from "../formSchema";
import type { SimulationHistoryItem } from "../types";

// Defaults dos campos do modo CSV (schema 1.1) para itens salvos antes deles.
// Garante que restaurar um item antigo limpe resquícios de um restore anterior.
const BESS_FIELD_DEFAULTS = {
  medicaoCsvFileName: "",
  submercado: "",
  dod: "90",
  pontoMedicaoBess: "",
};

// "1.1" → "1.2": três campos saíram do payload e situacaoUsina substituiu o
// booleano de consórcio. Aplicado depois do spread do item porque as chaves
// antigas ainda estão gravadas no histórico e sobrescreveriam os defaults.
function migrateToSchema12(item: SimulationHistoryItem): SimulationHistoryItem {
  const {
    isUsinaConsorcio,
    isDemandaOciosa,
    horasDisponiveisBateria,
    ...rest
  } = item as SimulationHistoryItem & {
    isUsinaConsorcio?: boolean;
    isDemandaOciosa?: boolean;
    horasDisponiveisBateria?: string;
  };

  return {
    ...rest,
    situacaoUsina:
      rest.situacaoUsina ?? (isUsinaConsorcio ? "USINA_CONSORCIO" : "NOVA"),
    mesReferencia: rest.mesReferencia ?? "",
    perfilConsumo: rest.perfilConsumo ?? "",
  };
}

export function normalizeSimulationHistoryItem(
  item: SimulationHistoryItem
): SimulationHistoryItem {
  if (item.schema === CURRENT_FORM_SCHEMA) {
    return item;
  }

  if (item.schema) {
    // "1.0"/"1.1" → "1.2": campos novos do modo CSV + migração do schema 1.2
    return migrateToSchema12({
      ...BESS_FIELD_DEFAULTS,
      ...item,
      schema: CURRENT_FORM_SCHEMA,
    });
  }

  // Itens sem schema: além dos campos novos, corrige o swap histórico
  // demandaUsina/potenciaUsina (migração pré-1.0)
  return migrateToSchema12({
    ...BESS_FIELD_DEFAULTS,
    ...item,
    schema: CURRENT_FORM_SCHEMA,
    demandaUsina: item.potenciaUsina ?? item.demandaUsina,
    potenciaUsina: item.demandaUsina ?? item.potenciaUsina,
  });
}
